export default __webpack_public_path__ + "images/intuit-logo.18081c7de69b3e61ef8b5be4699fa79a.png";